import { Injectable } from "@angular/core";
import { MAP_MODULE_NAMES } from "src/models/common/EnumMapas";
import { BehaviorSubject } from "rxjs";
import { CloropetConfiguration } from "src/models/CloropetClases";
import { EncriptionService } from "src/app/features/shared/services/Encription.service";
import { LocalStorageService } from "src/app/features/shared/services/LocalStorage.service";
import { SessionService } from "src/app/features/shared/services/Session.service";
import { PotentialZonesLayerControlService } from "./PotentialZonesLayerControl.service";
import { HierarchyLevel } from "../../../ui/organisms/polygon-selector-with-levels/models/polygon-selector-with-levels.models";


@Injectable({
  providedIn: "root",
})
export class PotentialZonesMapSectionService {
  isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  //"TOP", "NOMADA", "POBLACION", "OPORTUNIDAD", "ZONA ROJA", "ZONA MAYA"
  agebCloropetConfig: CloropetConfiguration = {
  propertyName: 'TipoZona',
  clases: [
    { classProperty: 'OPORTUNIDAD', classValue: 'rgb(46, 125, 50)' }, 
    { classProperty: 'TOP', classValue: 'rgb(249, 168, 37)' },
    { classProperty: 'POBLACION', classValue: 'rgb(255, 242, 65)' },
    { classProperty: 'NOMADA', classValue: 'rgb(198, 40, 164)' },
    { classProperty: 'ZONA ROJA', classValue: 'rgb(198, 40, 40)' },
    { classProperty: 'ZONA MAYA', classValue: 'rgb(116, 252, 145)' },
  ]
};
  
  isVisible: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(private sessionService:  SessionService, 
      private localStorageService:  LocalStorageService, 
      private encriptionService:  EncriptionService,
      private potentialZonesLayerControlService: PotentialZonesLayerControlService){
  }

  setLoading(isLoading: boolean){
    this.isLoading.next(isLoading);
  }

  setIsPotentialZonesVisible(resp: boolean) {
      this.isVisible.next(resp);
  }

  getIsPotentialZonesVisible() {
    return this.isVisible.asObservable();
  }

  initializePotentialZonesMapSection() {
      // const current = this.sessionService.loadedMapComponents.value;
      // this.sessionService.loadedMapComponents.next([...current, MAP_MODULE_NAMES.Potential_Zones]);
      // this.addViewAsLoadedToStorage();
  }

  async loadLayers(): Promise<HierarchyLevel[]> {
    try {
      // this.potentialZonesLayerControlService.configure(this.selectorWithLevelsPrefixAdd);
              
      const hierarchyLevels = await this.potentialZonesLayerControlService.loadLayersFromAPI(1);
      // el dummy
      // const hierarchyLevels = await this.potentialZonesLayerControlService.loadLayersFromAssetsDummy();
      await this.potentialZonesLayerControlService.createAllSourcesAndLayers(this.agebCloropetConfig);
      return hierarchyLevels;
    } catch (error) {
      // const hierarchyLevels = await this.potentialZonesLayerControlService.loadLayersFromAssetsDummy();
      return [];
    }
  }

  loadLocationsGeoJson(geoJson: any): void {
    this.potentialZonesLayerControlService.loadMoreLocationGeoJson(geoJson);
  }

  sendLocationsToTop(): void {
    this.potentialZonesLayerControlService.sendLocationsToTop();
  }

  clearLocations(): void {
    this.potentialZonesLayerControlService.clearLocations();
  }

  destroyLayers(): void {
    this.potentialZonesLayerControlService.destroy();
  }

    // addViewAsLoadedToStorage(){
    //     const mapLoadedViewsEnc = this.localStorageService.getMapLoadedViews();
    //     if (mapLoadedViewsEnc == null) {
    //         return;
    //     }
    
    //     const decrypted = this.encriptionService.DecryptData(mapLoadedViewsEnc);
    //     if (decrypted == null) {
    //         this.localStorageService.setMapLoadedViews(this.encriptionService.EncryptData(JSON.stringify([MAP_MODULE_NAMES.Potential_Zones])) );
    //         this.sessionService.loadedMapComponents.next([MAP_MODULE_NAMES.Potential_Zones]);
    //         return;
    //     }
    
    //     var arr: any[] = [];
    //     try {
    //         const parsed = JSON.parse(decrypted);
    //         arr = parsed;
    //     } catch (e) {
    //         arr = [];
    //     }
    
    //     const key = MAP_MODULE_NAMES.Potential_Zones;
    //     if (!arr.includes(key)) {
    //         arr.push(key);
    //         this.localStorageService.setMapLoadedViews(this.encriptionService.EncryptData(JSON.stringify(arr)) );
    //         this.sessionService.loadedMapComponents.next(arr);
    //     }
    // }


}